import { ScaleElement } from '@scale/base-element';

class ScaleComparison extends ScaleElement {
  #initialPosition = 50;

  setup() {
    const mode = this.getAttribute('data-mode');
    if (mode === 'slider') this.#setupSlider();
    if (mode === 'stacked') this.#setupStacked();
    if (mode === 'overlay') this.#setupOverlay();
  }

  #setupSlider() {
    const slider = this.ref('slider');
    if (!slider || !this.ref('container')) return;

    this.#initialPosition = this.getNumber('data-position', 50);
    slider.value = this.#initialPosition;
    this.#sync(this.#initialPosition);

    slider.addEventListener('input', () => this.#sync(slider.value), { signal: this.signal });
  }

  #setupStacked() {
    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
    const skipped = this.checkVisibility?.({ contentVisibilityAuto: true }) === false;
    if (!skipped && this.getBoundingClientRect().top < window.innerHeight) return;

    this.setAttribute('data-stacked-enter', '');
    const stop = this.onScreen((shown) => {
      if (!shown) return;
      stop();
      this.removeAttribute('data-stacked-enter');
    }, 0.3);
  }

  #setupOverlay() {
    const reveal = this.ref('reveal');
    if (!reveal) return;

    let pointerType = '';
    const track = (event) => {
      if (event.pointerType === 'mouse') this.toggleAttribute('data-hovered', event.type === 'pointerenter');
    };
    reveal.addEventListener('pointerenter', track, { signal: this.signal });
    reveal.addEventListener('pointerleave', track, { signal: this.signal });
    reveal.addEventListener('pointerdown', (event) => { pointerType = event.pointerType; }, { signal: this.signal });

    reveal.addEventListener('click', () => {
      const fromMouse = pointerType === 'mouse';
      pointerType = '';
      if (fromMouse) return;
      const revealed = reveal.getAttribute('aria-pressed') !== 'true';
      reveal.setAttribute('aria-pressed', String(revealed));
      this.toggleAttribute('data-revealed', revealed);
    }, { signal: this.signal });
  }

  #sync(value) {
    this.ref('container')?.style.setProperty('--compare', parseFloat(value));
  }

  onBlockSelect() {
    const slider = this.ref('slider');
    if (slider) {
      slider.value = this.#initialPosition;
      this.#sync(this.#initialPosition);
    }
  }
}

if (!customElements.get('scale-comparison')) {
  customElements.define('scale-comparison', ScaleComparison);
}
